export const MAX_RULES_TO_SHOW = 5
export const MAX_READ_ONLY_RULES_TO_SHOW = 3
